import cn from 'classnames';
import React, { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';

// CSS
import styles from '@UILayer/UILayer.scss';

// REDUX
import { IGamePlayMessages } from '@GFTypes/GameStoreTypes';
import { getGamePlayMessages, getGlobalStyles } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';

import { DOM_ID } from '@UILayer/UILayer.types';

const WinningInformation: React.FC<{}> = () => {
    const [state, setState] = useReducer((state: Partial<IGamePlayMessages>, newState: any) => ({ ...state, ...newState }), {
        winning: '',
        showWinning: false
    });

    const gameStoreGamePlayMessages = useAppSelector(getGamePlayMessages);
    const globalStyles = useAppSelector(getGlobalStyles);
    const { t } = useTranslation();
    const winningCN = cn(styles.winning_container, globalStyles.orientation);

    useEffect(() => {
        const { winning, showWinning } = gameStoreGamePlayMessages;

        setState({
            winning: winning,
            showWinning: showWinning
        });
    }, [gameStoreGamePlayMessages]);

    return (
        <div className={winningCN} aria-live="assertive" tabIndex={0} aria-description={t('WCA_WIN_MESSAGE_INFORMATION')} aria-valuetext={state.winning}>
            <span id={DOM_ID.WIN_INFORMATION}>{state.winning}</span>
        </div>
    );
};

export default WinningInformation;
